import formValidation from 'formvalidation/core/Core';
import SubmitButton from 'formvalidation/plugins/SubmitButton';
import DefaultSubmit from 'formvalidation/plugins/DefaultSubmit';
import Message from 'formvalidation/plugins/Message';
import Excluded from 'formvalidation/plugins/Excluded';
import Trigger from 'formvalidation/plugins/Trigger';
import ValidationUtils from '../../utils/validation';
import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import EventHandler from '../../utils/dom/event-handler';

const EVENT_KEY = `lta.wimbledonballot`;
const EVENT_CHANGE = `change.${EVENT_KEY}`;
const CLASS_HIDDEN = 'u-hidden';
let FV;

class WimbledonBallot {
	constructor() {
		this._accessQuestionInput = SelectorEngine.findOne('.js-p-wimbledon-ballot-access-q input');
		this._dayPrefQuestion = SelectorEngine.findOne('.js-p-wimbledon-ballot-daypref-q');
		this._accessibleAccessTypeQuestion = SelectorEngine.findOne('.js-accessibleAccessType-q');
		this._accessQuestionsGroup = SelectorEngine.findOne('.js-p-wimbledon-ballot-access-q-group');
		this._dayPrefQuestionsGroup = SelectorEngine.findOne('.js-p-wimbledon-ballot-daypref-q-group');
		this._accessibleAccessDetailsTextArea = SelectorEngine.findOne('.js-textarea-counter');

		this.wimbledonBallotForm = SelectorEngine.findOne('#wimbledon-ballot-form');

		this.initEvents();
		this.initFormEvents();
	}

	initEvents() {
		// If `I require accessible seating` checked show all access questions
		if (this._accessQuestionInput !== null) {
			EventHandler.on(this._accessQuestionInput, EVENT_CHANGE, (event) => {
				const checkbox = event.target;

				if (checkbox.checked) {
					this._accessQuestionsGroup.classList.remove(CLASS_HIDDEN);
				} else {
					this._accessQuestionsGroup.classList.add(CLASS_HIDDEN);
				}
			});
		}

		if (this._dayPrefQuestion !== null) {
			EventHandler.on(this._dayPrefQuestion, EVENT_CHANGE, (event) => {
				const radio = event.target;

				if (radio.value.toLowerCase() === 'yes') {
					this._dayPrefQuestionsGroup.classList.remove(CLASS_HIDDEN);
				} else {
					this._dayPrefQuestionsGroup.classList.add(CLASS_HIDDEN);
				}
			});
		}

		// If `I require accessible seating` and `Ease of access` checked show the textarea for details.
		if(this._accessibleAccessTypeQuestion !== null) {
			EventHandler.on(this._accessibleAccessTypeQuestion, EVENT_CHANGE, (event) => {
				const radio = event.target;

				if (radio.value.toLowerCase() === 'easeofaccess') {
					this._accessibleAccessDetailsTextArea.classList.remove(CLASS_HIDDEN);
				} else {
					this._accessibleAccessDetailsTextArea.classList.add(CLASS_HIDDEN);
				}
			});
		}
	}

	initFormEvents() {
		if (!this.wimbledonBallotForm) {
			return;
		}

		const formFields = {
			members: {
				accessibleAccessType: {
					validators: {
						notEmpty: {
							message: 'Please indicate what type of access you require'
						}
					}
				},
				accessibleAccessDetails: {
					validators: {
						notEmpty: {
							message: 'Please describe your ease of access requirement'
						},
						regexp: {
							regexp: /^[a-zA-Z0-9\s,.\-#/]{1,320}$/,
							message: 'Please enter a valid access requirement'
						}
					}
				}
			},
			coaches: {
				attendDayPreference: {
					validators: {
						notEmpty: {
							message: 'Please indicate if you have a preferred day(s)'
						}
					}
				},
				accessibleAccessType: {
					validators: {
						notEmpty: {
							message: 'Please indicate what type of access you require'
						}
					}
				},
				accessibleAccessDetails: {
					validators: {
						notEmpty: {
							message: 'Please describe your ease of access requirement'
						},
						regexp: {
							regexp: /^[a-zA-Z0-9\s,.\-#/]{1,320}$/,
							message: 'Please enter a valid access requirement'
						}
					}
				}
			},
			volunteersOfficials: {
				accessibleAccessType: {
					validators: {
						notEmpty: {
							message: 'Please indicate what type of access you require'
						}
					}
				},
				accessibleAccessDetails: {
					validators: {
						notEmpty: {
							message: 'Please describe your ease of access requirement'
						},
						regexp: {
							regexp: /^[a-zA-Z0-9\s,.\-#/]{1,320}$/,
							message: 'Please enter a valid access requirement'
						}
					}
				}
			}
		};

		FV = formValidation(
			this.wimbledonBallotForm,
			{
				fields: formFields[Manipulator.getDataAttribute(this.wimbledonBallotForm, 'type')],
				plugins: {
					trigger: new Trigger(),
					submitButton: new SubmitButton(),
					defaultSubmit: new DefaultSubmit(),
					message: new Message({
						clazz: 'lta-text-input__label-instruction',
						container: function(field, element) {
							const fieldType = element.getAttribute('type');
							const inputWrapper = element.closest(ValidationUtils.getFieldWrapper(fieldType));
							return inputWrapper.querySelector('.lta-text-input--error');
						}
					}),
					excluded: new Excluded()
				}
			}
		)
			.on('core.field.invalid', (name) => {
				const invalidField = document.getElementsByName(name)[0];
				const invalidFieldType = invalidField.getAttribute('type');
				const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper(invalidFieldType));
				fieldWrapper.classList.add(...ValidationUtils.getErrorClasses(invalidFieldType));
			})
			.on('core.field.valid', (name) => {
				const invalidField = document.getElementsByName(name)[0];
				const invalidFieldType = invalidField.getAttribute('type');
				const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper(invalidFieldType));
				fieldWrapper.classList.remove(...ValidationUtils.getErrorClasses(invalidFieldType));
			})
			.on('core.form.valid', () => {
				// const formData = new FormData(paymentForm);
				// const dataObject = {};
				// formData.forEach((value, key) => {
				// 	dataObject[key] = value;
				// })

				// FV.resetForm(true);
			});
	}
}

const globalWimbledonBallot = new WimbledonBallot();

export default globalWimbledonBallot;
